import React, { useEffect, useState, useReducer }  from 'react'
import {Col, Container, Row, Carousel, Button, Spinner, Badge} from 'react-bootstrap'
import { useParams } from 'react-router'

import creditCard from "../images/credit-card.webp"

 function Product({productsData}) {
  const {id} =useParams()
  const[product, setProduct] = useState({})
  const[loading, setLoading] = useState(true)
  useEffect(() =>  {
      setProduct(productsData.filter(el => el.id == id) )
      setLoading(false)
      console.log(product);
    },[])
    return loading ? <Container style={{width:"100vw",height:"95vh"}}><Spinner style={{position:"absolute", top:"50%", left:"50%", transform:"translate(-50%,-50%)"}} animation="grow" variant="secondary" /></Container>
       : <Container>                                     
            <Row>
              {console.log(product)}
                <Col lg={4} >
                <Carousel  fade >
  <Carousel.Item >
    <img
      className="d-block w-100"
      src={product[0].image}
      alt="First slide"
      style={{objectFit:"contain"}}
    />
    
  </Carousel.Item>

</Carousel>
                </Col>
                <Col lg={5}>
                <span>{product.brand || ''}</span>
                <h6 className="product-title mb-5 fw-bold">{product[0].title}</h6>
                
                {/* <Col className="quantity d-flex align-items-baseline">
                  <h6 className="fs-5 fw-bold  text-capitalize me-5">Quantity:</h6>
                  
                </Col> */}
                <Col className="my-4">
                <small className=" my-1 d-block text-capitalize">Item Location: {product[0].itemLocation}</small>
                <small className=" my-1 d-block text-capitalize">Condition: {product[0].condition}</small>
                </Col>
                <Col className="product-info ">
                  <small className=" my-1 d-block text-capitalize">Shipping: {product[0].shipping}</small>
                  <small className=" my-1 d-block  text-capitalize">Shipping Cost: {product[0].shippingCost}</small>
                  <small className=" my-1 d-block  text-capitalize">Returns: {product[0].returns}</small>
                  <small className=" my-1 d-block  text-capitalize">Paymanets: {product[0].paymanets}</small>
                  <small className="fs-6 fw-bold">Price: {product[0].price}$</small>
                  
                  <Row>
                    <Col><img src={creditCard} alt="credit-card.webp" />
                    </Col>
                    <Col className="p-0 d-flex">
                    <div className=" d-inline-flex align-items-center m-2">
                <Button className="w-25 bg-secondary" style={{outline:"none", border:"none", boxShadow:"none"}}>-</Button>
                <Badge className="fs-6 fw-bolder p-2 bg-light text-secondary" style={{width:"100px"}}>0</Badge>
                <Button className="w-25 bg-secondary" style={{outline:"none", border:"none", boxShadow:"none"}}>+</Button>
                </div>
                    <Button className="d-block m-2  bg-secondary border-0" style={{width:"150px"}}>Buy Now</Button>
                    <Button className="d-block m-2  bg-secondary border-0" style={{width:"150px"}}>Add to cart</Button>
                    </Col>
                  </Row>
                </Col>
                </Col>
                <Col lg={3} className="border-left bordor-1 border-dark" style={{maxWidth:"200px"}}><h6 className="fw-bold">Seller information</h6></Col>
            </Row>
            <Row className="description">
             <Col className="py-4">
                <h4 className="fw-bold py-5">Description</h4>
               <pre style={{whiteSpace:"pre-line"}}>{product[0].description}</pre></Col> 
            </Row>

        </Container>
    
}

export default Product
